/**
 * 检测是否为移动设备
 * 基于 userAgent 判断，而不是窗口宽度
 */
export function isMobileDevice() {
  if (typeof window === 'undefined') {
    return false
  }
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || ''
  
  // 检测移动设备的关键词（更全面的匹配）
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|windows phone|kindle|silk|fennec|maemo|symbian|symbos|series60|series40|playbook|bb10|palm|palmos|avantgo|blazer|elaine|hiptop|plucker|xiino|windows ce|smartphone|ipad|ipod|iphone|android|blackberry|opera|mini|windows mobile|pda|mobile|phone/i
  
  // 检测触摸设备
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
  
  // 检测屏幕尺寸（作为辅助判断）
  const isSmallScreen = window.innerWidth <= 768
  
  // 如果是移动设备 userAgent 或者（触摸设备且小屏幕），则认为是移动设备
  return mobileRegex.test(userAgent) || (hasTouchScreen && isSmallScreen)
}

/**
 * 检测是否为平板设备
 */
export function isTabletDevice() {
  if (typeof window === 'undefined') {
    return false
  }
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  
  // 检测平板设备的关键词
  const tabletRegex = /ipad|android(?!.*mobile)|tablet/i
  
  return tabletRegex.test(userAgent)
}

/**
 * 检测是否为手机设备
 */
export function isPhoneDevice() {
  return isMobileDevice() && !isTabletDevice()
}
